(() => {
  if (window.avoraPdpReady) return;
  window.avoraPdpReady = true;
  const setup = () => {
    const root = document.querySelector('product-info.avh-pdp');
    if (!root || root.dataset.avhReady) return;
    root.dataset.avhReady = 'true';
    let frame;
    let variantSource;
    let variant;
    let availabilitySource;
    let availabilityVariants = new Map();
    let currencyFormat;
    let currencyFormatKey;
    const sync = () => {
      frame = 0;
      const fullSet = root.querySelector('avora-full-set[data-mode="product"]');
      const button = fullSet?.querySelector('[data-avfs-add]') || root.querySelector('product-form [name="add"]');
      const tier = root.querySelector('.Avada-Volume__Item--Selected');
      const picker = root.querySelector('variant-selects');
      const nextVariantSource = picker?.querySelector('script[data-selected-variant]')?.textContent || 'null';
      if (variantSource !== nextVariantSource) {
        variantSource = nextVariantSource;
        variant = null;
        try { variant = JSON.parse(variantSource); } catch (_) {}
      }
      const availability = root.querySelector('[data-avh-availability]');
      if (availability) {
        const nextAvailabilitySource = root.querySelector('[data-avh-availability-variants]')?.textContent || '[]';
        if (availabilitySource !== nextAvailabilitySource) {
          availabilitySource = nextAvailabilitySource;
          availabilityVariants = new Map();
          try { availabilityVariants = new Map(JSON.parse(availabilitySource).map(option => [String(option.id), option])); } catch (_) {}
        }
        const idInput = fullSet?.querySelector('[data-avfs-id]') || root.querySelector('product-form form input[name="id"]');
        const selectedId = idInput?.value || variant?.id || availability.dataset.initialVariant;
        const selectedVariant = availabilityVariants.get(String(selectedId));
        const state = selectedVariant ? selectedVariant.available ? selectedVariant.tracked && selectedVariant.stock > 0 ? 'ready' : 'orderable' : 'sold_out' : availability.dataset.state || 'sold_out';
        const isReady = state !== 'sold_out';
        if (availability.classList.contains('avh-availability--ready') !== isReady) availability.classList.toggle('avh-availability--ready', isReady);
        if (availability.dataset.state !== state) availability.dataset.state = state;
        const label = availability.querySelector('[data-avh-availability-label]');
        const labelText = state === 'ready' ? availability.dataset.readyLabel : state === 'orderable' ? availability.dataset.orderableLabel : availability.dataset.soldOutLabel;
        if (label && labelText && label.textContent !== labelText) label.textContent = labelText;
      }
      const price = fullSet?.querySelector('[data-avfs-price]') || tier?.querySelector('.AOV-Offer__DiscountPrice') || root.querySelector('[data-avora-unit-cost]') || root.querySelector('[id^="price-"] .price-item--sale') || root.querySelector('[id^="price-"] .price-item--regular');
      let text = price?.textContent.trim() || '';
      if (!tier && !fullSet) {
        const unitPrice = variant?.price;
        const quantityInput = root.querySelector('input[name="quantity"]');
        const enteredQuantity = Number(quantityInput?.value || 1);
        const quantity = Number.isFinite(enteredQuantity) && enteredQuantity > 0 ? enteredQuantity : 1;
        if (typeof unitPrice === 'number' && Number.isFinite(unitPrice)) {
          const currency = root.dataset.currency || picker?.dataset.currencyCode || 'EUR';
          const locale = document.documentElement.lang || 'fi-FI';
          try {
            const nextFormatKey = `${locale}:${currency}`;
            if (currencyFormatKey !== nextFormatKey) {
              currencyFormat = new Intl.NumberFormat(locale, { style: 'currency', currency });
              currencyFormatKey = nextFormatKey;
            }
            text = currencyFormat.format(unitPrice * quantity / 100);
          } catch (_) {}
        }
      }
      if (button && text && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
        let output = button.querySelector('.avh-button-price');
        if (!output) { output = document.createElement('span'); output.className = 'avh-button-price'; button.append(output); }
        if (output.textContent !== text) output.textContent = text;
      } else button?.querySelector('.avh-button-price')?.remove();
      const selected = root.querySelector('variant-selects input:checked + label img');
      const stickyImage = document.querySelector('.avh-sticky-image');
      if (selected && stickyImage && stickyImage.src !== selected.src) { stickyImage.src = selected.src; stickyImage.removeAttribute('srcset'); }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !target?.closest('media-gallery, .avh-button-price, [data-avh-availability]');
      })) schedule();
    }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'] });
    root.addEventListener('change', schedule);
    root.addEventListener('input', schedule);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
